import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';

export default function QrRedirectPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [fehler, setFehler] = useState(false);

  useEffect(() => {
    api.get(`/q/${token}`)
      .then(r => navigate(`/behaelter/${r.data.behaelter_id}`, { replace: true }))
      .catch(() => setFehler(true));
  }, [token, navigate]);

  if (fehler) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '24px', textAlign: 'center', background: '#f8fafc' }}>
        <div style={{ fontSize: '64px', marginBottom: '16px' }}>📦</div>
        <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#1e293b', margin: '0 0 12px' }}>Diese Kiste wurde nicht gefunden.</h1>
        <p style={{ color: '#64748b', fontSize: '14px', margin: '0 0 24px', maxWidth: '300px', lineHeight: '1.5' }}>
          Der QR-Code ist ungültig oder gehört zu keiner deiner Kisten.
        </p>
        <a href="/" style={{ padding: '12px 24px', background: '#f59e0b', color: 'white', borderRadius: '10px', fontWeight: '700', textDecoration: 'none', fontSize: '15px' }}>
          Zur Lager-App
        </a>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f8fafc' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
      <div style={{ color: '#64748b', fontSize: '15px' }}>Kiste wird gesucht…</div>
    </div>
  );
}
